export default function ({ store, redirect }) {
  if (!store.state.interactions.passwordExpired) {
    // Se è già loggato va in dashboard, altrimenti al login
    if (store.state.auth.loggedIn) {
      return redirect('/area-riservata/dashboard')
    }
    return redirect('/area-riservata/login')
  }
}
